import { connect } from 'react-redux';
import { getCurrentAdSafety } from '../../../../Ads/redux/selectors';
var mapStateToProps = function (state) { return ({
    adSafety: getCurrentAdSafety(state) || '',
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Ad.container.js.map